import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'capitalize'})
export class CapitalizePipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    if (!value) { return value; }

    return value.replace(/[а-яА-ЯёЁ]*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/tools/pipes/capitalize.pipe.ts